import Axios from 'axios';
import { getJwt } from '@app/helpers';
import { trackPromise } from 'react-promise-tracker';

export const exportarPlanilhaOrcadoEconomicoAnoMes = (id: any, nomeDoArquivo: string) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/exportar/planilhaOrcadoEconomicoAnoMes/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadElement');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElement').outerHTML = '';
    }),
  );
};

export const exportarPlanilhaCapexAnoMes = (id: any, nomeDoArquivo: string) => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/exportar/planilhaCapexAnoMes/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadElement');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElement').outerHTML = '';
    }),
  );
};

export const exportaPlanilhaRfaAnoMes = (id: any, nomeDoArquivo: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/exportar/planilhaRfaAnoMes/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadElement');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElement').outerHTML = '';
    }),
  );
};

export const exportaPlanilhaRfaAntiga = (
  id: any,
  nomeDoArquivo: string,
  numero: number,
  revisao: number,
  dataAprovacao: string,
) => {
  let d = dataAprovacao.split('/');
  let data = new Date(d[2], d[1] - 1, d[0]);
  dataAprovacao = data.toISOString();

  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(
      urlBase +
      `/api/exportar/planilhaRfaAntiga/id/${id}/numero/${numero}/revisao/${revisao}/dataAprovacao/${dataAprovacao}`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${getJwt()}`,
        },
      },
    ).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadElement');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElement').outerHTML = '';
    }),
  );
};

export const exportaPlanilhaCapexAntiga = (
  id: any,
  nomeDoArquivo: string,
  numero: number,
  revisao: number,
  dataAprovacao: string,
) => {
  let d = dataAprovacao.split('/');
  let data = new Date(d[2], d[1] - 1, d[0]);
  dataAprovacao = data.toISOString();

  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(
      urlBase +
      `/api/exportar/planilhaCapexAntiga/id/${id}/numero/${numero}/revisao/${revisao}/dataAprovacao/${dataAprovacao}`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${getJwt()}`,
        },
      },
    ).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadElement');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElement').outerHTML = '';
    }),
  );
};

export const exportaModelo = (tipo: string) => {
  let urlBase = window.location.origin;
  let nomeArquivo = '';
  switch (tipo) {
    case 'modeloTap':
      urlBase += `/api/exportar/modeloTap`;
      nomeArquivo = 'MODELO - Importacao TAP FINPLAN AAAA.xlsx';
      break;
    case 'modeloExecutado':
      urlBase += `/api/exportar/modeloExecutado`;
      nomeArquivo = 'MODELO - Executado MM-AAAA.xlsx';
      break;
    case 'modeloOrcadoAnual':
      urlBase += `/api/exportar/modeloOrcadoAnual`;
      nomeArquivo = 'MODELO - Orcado ANUAL de AAAA.xlsx';
      break;
    case 'modeloOrcadoCapex':
      urlBase += `/api/exportar/modeloOrcadoAnual`;
      nomeArquivo = 'MODELO - Orcado CAPEX do projeto XXXNNNN.xlsx';
      break;
    case 'modeloOrcadoRfa':
      urlBase += `/api/exportar/modeloOrcadoRfa`;
      nomeArquivo = 'MODELO - Orcado RFA do projeto XXXNNNN.xlsx';
      break;
    default:
      urlBase;
  }

  trackPromise(
    Axios.get(urlBase, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      link.setAttribute('id', 'downloadElement');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElement').outerHTML = '';
    }),
  );
};
